import DeptSelectDialog from './DeptSelectDialog';

export default DeptSelectDialog;
